/* eslint-disable no-use-before-define */
import React from 'react'
import { safeURL, openWindow, NO_RESULT_ICON, viewBack, } from '../twd'
import Header from './header'
import BondFeatures from './bond-features'
import OriginalIssuance from './original-issuance'
import ImportantDocuments from './important-documents'
import CreditRatings from './credit-ratings'
import CouponFeatures from './coupon-features'
import RedemptionFeatures from './redemption-features'
import ReferenceInformation from './reference-information'
import BestOffering from './best-offering'
import MbsSpeed from './mbs-speed'
import { ContextProvider, useBondDetail } from './use-bond-detail'
import './bond-detail.css'

export default ({cusip, from=''} = {}) => {

    if (cusip) {
        location.hash = 'bond-detail.' + cusip
    }

    return <ContextProvider cusip={cusip}>
        <div className="bond-detail">
        <div style={{background:"#ffffff"}}>
        <div className="container">
        {from && from!=='bond-detail' && (<React.Fragment>
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{margin:0, padding:0, backgroundColor:'#fff'}}>
            <li className="breadcrumb-item" style={{margin:0, padding:0}}>
            <a href="#"
                className="link-button"
                onClick={() => {
                    let u = safeURL(from)
                    if (u) {
                        openWindow(u.toString())
                        return
                    }

                    viewBack()
                }}>
                <i
                    style={{color:'var(--primary-base-color)', fontSize:'13px', width:'10px'}}
                    className="material-icons"
                    aria-hidden="true"
                >navigate_before</i>
                Back
                </a>
                </li>
                <li className="breadcrumb-item active" style={{margin:0, padding:0}}>
                <span style={{ fontWeight:'500', color:'#242424' }} aria-current="page">Bond detail</span>
                </li>
                </ol>
            </nav>
            </React.Fragment>)}
        </div>
        </div>

        <Content />
        <div className="row vertical-offset-lg"></div>
        </div>
    </ContextProvider>
}


let Content = () => {
    let { cusip, status } = useBondDetail()

    if (status==='Not Found') {
        return <div className="container">
            <div className="row vertical-offset-lg">
            <div className="text-muted text-center">
                {NO_RESULT_ICON}
                <br/>Bond detail for {cusip} is not found.
            </div>
            </div>
            </div>
    }

    return <React.Fragment>
        <div style={{background:"#ffffff"}}>
        <div className="container">
        <div className="row vertical-offset-sm"></div>
        <Header />
        </div>
        </div>

        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container section-container">
        <div className="row vertical-offset-sm">

            <div className="col-xs-12 col-md-4">
                <BondFeatures />
                <ReferenceInformation />
                <OriginalIssuance />
                <MbsSpeed />
                <ImportantDocuments />
            </div>

            <div className="col-xs-12 col-md-4">
                <CreditRatings />
                <CouponFeatures />
                <RedemptionFeatures />
            </div>

            <div className="col-xs-12 col-md-4">
                <BestOffering />
            </div>
        </div>
        </div>
        </div>
    </React.Fragment>
}

export const INV_TYPE_LABELS = {
    'A': 'Agency',
    'R': 'Pass-Through',
    'K': 'Asset-Backed',
    'S': 'CD',
    'O': 'CMO',
    'C': 'Corporate',
    'M': 'Municipal',
    'P': 'Preferred',
    'L': 'Structured',
    'T': 'Treasury',
}



// WEBPACK FOOTER //
// ./src/bond-detail/bond-detail.js